import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { IVerksamhetsomraden } from "~app/features/regelverk-viol/regelverk-viol.models";

export class AddOrUpdateMatningsInformationStyrningCommand extends BasicCommand<AddOrUpdateMatningsInformationStyrningCommand> {
    get primaryKey(): IPrimaryKey<AddOrUpdateMatningsInformationStyrningCommand> {
        return {
            guid: this.guid
        };
    }
    id: number;
    guid: string;
    inmatningshandelssortiment: string;
    befraktareId: number;
    anskaffningsform: string[];
    affarsform: string[];
    transportslag: string;
    verksamhetsomraden: IVerksamhetsomraden[];
    mattslag: string;
    andraMattslag?: boolean;
    stockmatningKravs?: boolean;
    kvalitetsklassningKravs?: boolean;
    prioriteradMatmetod: string;

    static readonly $groupKey = "Redovisningshanvisning";
    static readonly $type = "AddOrUpdateMatningsInformationStyrningCommand";
    constructor(init: (instance: AddOrUpdateMatningsInformationStyrningCommand) => void) {
        super(AddOrUpdateMatningsInformationStyrningCommand.$type, AddOrUpdateMatningsInformationStyrningCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
